export default {
	name	: 'MainInput',
	props	: {
		value		: [String, Number],
		label		: String,
		type		: {
			type		: String,
			default		: 'text'
		},
		name		: String,
		placeholder	: String,
		disabled	: Boolean,
		maxlength	: Number,
		min			: String,
		max			: String,
		required	: Boolean,
		errorMessage: String
	},
	data() {
		return {
			touched: false
		}
	},
	computed: {
		hasError() {
			return this.errorMessage && this.touched
		}
	}
}
